import { initialState } from "./state"

export default {
  updateFilterParams(state, params) {
    Object.keys(params).forEach(key => {
      if (state.filter.hasOwnProperty(key)) {
        state.filter[key] = params[key]
      }
    })
  },
  resetSuspensions: state => {
    const INITIAL_STATE = initialState()
    Object.keys(state).forEach(key => {
      state[key] = INITIAL_STATE[key]
    })
  },
  setSuspensionTypes(state, suspensionTypes) {
    state.suspensionTypes = suspensionTypes.map(item => ({
      value: item.id,
      text: item.name
    }))
  }
}
